import { FilePond } from 'react-filepond'
import { Button } from 'react-bootstrap'
import 'filepond/dist/filepond.min.css'
import { useState } from 'react'
import toast from "react-hot-toast";

const GstrUploadBills = (props) => {
    const { handleUploadFile } = props;
    const [files, setFiles] = useState([]);
    const [textarea, setTextArea] = useState('');
    const [errors, setErrors] = useState({
        textarea: "",
        files: "",
    });

    const uploadLimit = 50;

    const handleChange = (e) => {
        const value = e.target.value;
        setTextArea(value);
        
        // Update errors in a single setState call
        setErrors(prevErrors => ({ 
            ...prevErrors, 
            textarea: value === '' ? 'Notes is Required' : '' 
        }));
    }

    const handleFilesUpdate = (fileItems) => {
        setFiles(fileItems);
        // Clear file validation error when files are selected
        if (fileItems.length > 0) {
            setErrors(prevErrors => ({ ...prevErrors, files: '' }));
        }
    }

    const handleSubmit = () => {
        if (typeof handleUploadFile == 'function') {
            let validationErrors = {};

            // Validate textarea
            if (!textarea) {
                validationErrors.textarea = 'Notes is Required';
            }

            // Validate files
            if (files.length === 0) {
                validationErrors.files = 'Please select at least one file';
            }

            // If there are validation errors, set them and return
            if (Object.keys(validationErrors).length > 0) {
                setErrors(prevErrors => ({ ...prevErrors, ...validationErrors }));
                return;
            }

            const fileData = files.map(fileItem => fileItem.file)
            handleUploadFile(fileData, textarea)
            setFiles([]);
            setTextArea('');
        }
    }

    const handleWarning = (error, file) => {
        const total_length = files.length + file.length;
        if (total_length > uploadLimit) {
            toast(`You can't upload more than ${uploadLimit} files.`);
            return;
        }
    };

    return (
        <>
            <FilePond
                className="my-pond filepond filepond_ip filepond-input-multiple"
                files={files}
                onupdatefiles={handleFilesUpdate}
                allowMultiple={true}
                maxFiles={uploadLimit}
                onwarning={handleWarning}
                name="files" /* sets the file input name, it's filepond by default */
                labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
            />
            {errors.files && <div class="invalid-feedback d-block">{errors.files}</div>}
            
            <div class="pa-note-block">
                <h5 className="mb-3">Notes</h5>
                <div className='input-group has-validation'>
                    <textarea
                        id="SRtextarea"
                        className={`form-control ${errors.textarea ? 'is-invalid' : ''}`}
                        onChange={handleChange}
                        rows="3"
                        value={textarea}
                    ></textarea>
                    {errors.textarea && <div class="invalid-feedback">{errors.textarea}</div>}
                </div>
                <Button className="mt-2" onClick={handleSubmit}>Upload</Button>
            </div>
        </>
    )
}

export default GstrUploadBills;